import { render } from "./MedicationDashboard.vue?vue&type=template&id=1803c660&ts=true"
import script from "./MedicationDashboard.vue?vue&type=script&lang=ts"
export * from "./MedicationDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__